// extracted by mini-css-extract-plugin
module.exports = {"bottomSignUp":"style_bottomSignUp__28-lx","logo":"style_logo__1CNyJ"};